import React from "react";
import { Box, Typography } from "@mui/material";
import SherpaIcon from "../../assets/Sherpa.svg";

const EmptyChatState = () => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: 2,
    }}
  >
    <Box sx={{ textAlign: "center", maxWidth: 560 }}>
      <Box
        component="img"
        src={SherpaIcon}
        alt="Sherpa"
        sx={{ width: 56, height: 56, mb: 2 }}
      />
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        How can I help you today?
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Ask questions about your workflows, processes, reports, or operational
        data.
      </Typography>
    </Box>
  </Box>
);

export default EmptyChatState;

